import styled, { css } from 'styled-components';
import { COLUMN_MINIMUM_WIDTH } from '../table/constants/sizes';
const LoadingCell = styled.div.attrs({
  'data-test-id': 'loading-cell'
})(({
  theme
}) => {
  return css(["display:block;height:20px;min-width:", ";background-color:", ";"], COLUMN_MINIMUM_WIDTH, theme.color['fill-primary-disabled']);
});
export default LoadingCell;